import React from "react"
import PropTypes from "prop-types"

const ArrowRight = ({ fillColor }) => (
  <svg
    width="28"
    height="10"
    viewBox="0 0 28 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.9243 5.42426C27.1586 5.18995 27.1586 4.81005 26.9243 4.57574L23.1059 0.757359C22.8716 0.523045 22.4917 0.523045 22.2574 0.757359C22.023 0.991674 22.023 1.37157 22.2574 1.60589L25.6515 5L22.2574 8.39411C22.023 8.62843 22.023 9.00833 22.2574 9.24264C22.4917 9.47696 22.8716 9.47696 23.1059 9.24264L26.9243 5.42426ZM0 5.6H26.5V4.4H0V5.6Z"
      fill={fillColor}
    />
  </svg>
)

ArrowRight.propsTypes = {
  fillColor: PropTypes.string,
}

ArrowRight.defaultProps = {
  fillColor: "#414141",
}

export { ArrowRight }
